import ReactDOM from 'react-dom'
import OverlayModal from './Backdrop/OverlayModal';
import BackdropModal from './Backdrop/BackdropModal';

const Overlay = (props) => {
    return (
      <>
        {ReactDOM.createPortal(
          <BackdropModal onClose={props.closeOverlay}/>,
          document.getElementById('backdrop-root')
        )}
        {ReactDOM.createPortal(
          <OverlayModal
            title={props.title}
            content={props.content}
            onClose={props.closeOverlay}
            />,
            
          document.getElementById('overlay-root')
        )}
      </>
    );
  }

export default Overlay;